
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account/reset-password",
      function () {
        return require("private-next-pages/account/reset-password.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/account/reset-password"])
      });
    }
  